// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xP7VZ","inner":"styles_inner__97AHp","container":"styles_container__utH5p","swipe":"styles_swipe__Mbgzu"};